/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExtensionProfitPreviewItemDTO interface.
 */
export function instanceOfExtensionProfitPreviewItemDTO(value) {
    return true;
}
export function ExtensionProfitPreviewItemDTOFromJSON(json) {
    return ExtensionProfitPreviewItemDTOFromJSONTyped(json, false);
}
export function ExtensionProfitPreviewItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'asin': json['asin'] == null ? undefined : json['asin'],
        'title': json['title'] == null ? undefined : json['title'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'itemPrice': json['itemPrice'] == null ? undefined : json['itemPrice'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}
export function ExtensionProfitPreviewItemDTOToJSON(json) {
    return ExtensionProfitPreviewItemDTOToJSONTyped(json, false);
}
export function ExtensionProfitPreviewItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'asin': value['asin'],
        'title': value['title'],
        'quantity': value['quantity'],
        'itemPrice': value['itemPrice'],
        'currencyCode': value['currencyCode'],
    };
}
